import Polyglot from 'node-polyglot';
import getConfig from 'next/config';

import {getRandomKey} from '~/src/utilities/helpers/string';

const {publicRuntimeConfig} = getConfig();
const polyglot = new Polyglot({
    locale: publicRuntimeConfig.language,
    pluralRules: {
        pluralTypes: {
            zeroOneMore: (n) => Math.max(0, Math.min(n, 2))
        },
        pluralTypeToLanguages: {
            zeroOneMore: ['de', 'fr', 'en']
        }
    }
});

const initPolyglot = (config: any): ((key: string, params?: any) => string) => {
    const prefix = getRandomKey();
    polyglot.extend({[prefix]: config});
    return (key, params) => polyglot.t(`${prefix}.${key}.tenant-${publicRuntimeConfig.tenantId}`, params);
};

export default initPolyglot;
